import { ArrowBack } from 'ui/icons/navigation/ArrowBack';
import { Overflow } from 'ui/icons/navigation/Overflow';

import {
  MessageHeaderAndroid,
  MessageBody,
  MessageBodyAndroidDate,
  MessageBodyAndroidMessageContainer,
  MessageBodyAndroidMessage,
} from './Wrapper.styled';

export const AndroidWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <MessageHeaderAndroid>
        <ArrowBack color={`#35B8C0`} height={22} width={22} />
        <Overflow color={`#35B8C0`} height={22} width={22} />
      </MessageHeaderAndroid>
      <MessageBody>
        <MessageBodyAndroidDate>Today, 2:30</MessageBodyAndroidDate>
        <MessageBodyAndroidMessageContainer>
          <MessageBodyAndroidMessage data-test="template-diff-sms-preview-android-message">
            {children}
          </MessageBodyAndroidMessage>
        </MessageBodyAndroidMessageContainer>
      </MessageBody>
    </>
  );
};
